import { Scope } from "@corpuscomplete/core/common/scope";
import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";
import { useAuth } from "@corpuscomplete/web/auth/hooks";
import { PlannedMealsCalendarPage } from "@corpuscomplete/web/modules/nutrition/planned-meal/pages/planned-meals-calendar";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/planned-meals/$date")({
  params: {
    parse: ({ date }) => ({ date: Temporal.PlainDate.from(date) }),
    stringify: ({ date }) => ({ date: date.toString() }),
  },
  loader: async ({ context: { zero, actor }, params }) => {
    if (!zero) return;
    PlannedMealCalendar.preload(zero, {
      scopeId: actor.userId,
      focusedDate: params.date,
      timeZone: Temporal.Now.timeZoneId(),
    });
  },
  onError: () => {
    throw redirect({
      to: "/personal/planned-meals/$date",
      params: { date: Temporal.Now.plainDateISO() },
    });
  },
  component: () => {
    const { date } = Route.useParams();
    const { userId } = useAuth();
    return <PlannedMealsCalendarPage focusedDate={date} scope={Scope.personal(userId)} />;
  },
});
